import React from "react";
import Navbar from "./Navbar";
import SignOut from "./SignOut";
import Footer from "./footer";
import WorkspacePageContext from "./WorkspacePageContext";
import "./WorkspacePage.css";

export default function WorkspacePage({ title, actions, className = "", legacy = false, children }) {
  return (
    <div className={`workspace-page${legacy ? " workspace-page--legacy" : ""} ${className}`}>
      <header className="workspace-header">
        <div className="workspace-title"><Navbar /><h1>{title}</h1></div>
        <div className="workspace-header-actions">{actions}<SignOut /></div>
      </header>
      <main className="workspace-body">
        <WorkspacePageContext.Provider value={legacy}>
          {legacy ? <div className="workspace-legacy-content">{children}</div> : children}
        </WorkspacePageContext.Provider>
      </main>
      <Footer />
    </div>
  );
}